<template id="SaibaComo">
  <v-ons-page id="SaibaComoPage">
    <v-row style="margin-top: 30px">
      <v-col>
        <h2 class="titulo">Veja aqui o que falta preencher:</h2>

        <v-row
          style="width: 1000px; margin: 60px auto"
          class="d-flex justify-space-around"
        >
          <v-card class="card_1">
            <div class="circulo" :style="myStyle">
              <v-icon color="#000">
                mdi-store
              </v-icon>
            </div>
            <h1>Minha Loja</h1>
            <v-divider style="margin: 0 auto"></v-divider>
            <router-link to='/MinhaLoja' style="width: 100%; color: transparent">
              <h2 class="clique">Clique aqui para ver</h2>
            </router-link>
          </v-card>

          <v-card class="card_1">
            <div class="circulo" :style="myStyle_2">
              <v-icon color="#000">
                mdi-silverware
              </v-icon>
            </div>
            <h1>Cardápio</h1>
            <v-divider style="margin: 0 auto"></v-divider>
            <router-link to='/Cardapio' style="width: 100%; color: transparent">
              <h2 class="clique">Clique aqui para ver</h2>
            </router-link>
          </v-card>

          <v-card class="card_1">
            <div class="circulo" :style="myStyle_3">
              <v-icon color="#000">
                mdi-qrcode
              </v-icon>
            </div>
            <h1>QR Codes</h1>
            <v-divider style="margin: 0 auto"></v-divider>
            <router-link to='/QrCodes' style="width: 100%; color: transparent">
              <h2 class="clique">Clique aqui para ver</h2>
            </router-link>
          </v-card>

          <v-card class="card_1">
            <div class="circulo" :style="myStyle_4">
              <v-icon color="#000">
                mdi-plus-circle-outline
              </v-icon>
            </div>
            <h1>Funções</h1>
            <v-divider style="margin: 0 auto"></v-divider>
            <router-link to='/Funcionalidades' style="width: 100%; color: transparent">
              <h2 class="clique">Clique aqui para ver</h2>
            </router-link>
          </v-card>

          <!-- <v-card class="card_1">
            <div class="circulo" :style="myStyle_5">
              <v-icon color="#000">
                mdi-timer-sand-full
              </v-icon>
            </div>
            <h1>Quiz</h1>
            <v-divider style="margin: 0 auto"></v-divider>
            <router-link to='/Quiz' style="width: 100%; color: transparent">
              <h2 class="clique">Clique aqui para ver</h2>
            </router-link>
          </v-card> -->
        </v-row>
      </v-col>
    </v-row>

    <v-row style="margin-top: 0" class="d-flex justify-center">
      <h2 class="titulo">Que tal dar uma olhada no seu cardápio ?</h2>
    </v-row>
    <v-row class="d-flex justify-center">
      <v-button class="botao" @click="openCardapio()">Visualizar</v-button>
    </v-row>

    <v-row style="margin-top: 30px">
      <v-col>
        <h2 class="titulo">Passo a Passo</h2>
      </v-col>
    </v-row>

    <v-row class="d-flex justify-center" style="margin-top: 10px">
      <h2 class="sub_titulo">Para seu cliente:</h2>
    </v-row>

    <v-row class="cliente">
      <v-card>
        <img src="../assets/img/Qr_passo_1.png" width="73" />
        <p>
          Basta você colocar o QR Code nas mesas, área de espera e materiais da
          casa.
        </p>
      </v-card>
      <v-card>
        <img src="../assets/img/Qr_passo_2.png" width="73" />
        <p style="width: 130px; margin: 0 auto !important; margin-top: 70px;">
          Cliente habilita câmera e aponta para QR Code.
        </p>
      </v-card>
      <v-card>
        <img src="../assets/img/Qr_passo_3.png" width="73" />
        <p>Cliente faz tudo no próprio celular.</p>
      </v-card>
    </v-row>

    <v-row class="d-flex justify-center" style="margin-top: 50px">
      <h2 class="sub_titulo">Para você habilitar:</h2>
    </v-row>

    <v-row class="habilitar">
      <v-card class="d-flex flex-column align-center">
        <img src="../assets/img/ylw_icoLoja.png" width="73" />
        <p>Cadaste seu estabelecimento em Minha Loja.</p>
        <v-divider></v-divider>
        <router-link to='/MinhaLoja' style="color: transparent;">
          <h2 class="clique">Saiba mais...</h2>
        </router-link>
      </v-card>

      <v-card class="d-flex flex-column align-center">
        <img src="../assets/img/ylw_icoCardapio.png" width="73" />
        <p style="width: 179px">
          Insira as suas imagens de cardápio e promoções em cardápio.
        </p>
        <v-divider></v-divider>
        <router-link to='/Cardapio' style="color: transparent;">
          <h2 class="clique">Saiba mais...</h2>
        </router-link>
      </v-card>

      <v-card class="d-flex flex-column align-center">
        <img src="../assets/img/ylw_icoQr.png" width="73" />
        <p>
          Em QR Codes defina a quantidade de mesas, os nomes delas, imprima ou
          baixe a imagem dos QR CODES para aplicar nos materiais.
        </p>
        <v-divider></v-divider>
        <router-link to='/QrCodes' style="color: transparent;">
          <h2 class="clique">Saiba mais...</h2>
        </router-link>
      </v-card>

      <v-card class="d-flex flex-column align-center">
        <img src="../assets/img/ylw_icoFunc.png" width="73" />
        <p>
          Definida as funções que desejar que seu aplicativo possua em funções.
        </p>
        <v-divider></v-divider>
        <router-link to='/Funcionalidades' style="color: transparent;">
          <h2 class="clique">Saiba mais...</h2>
        </router-link>
      </v-card>

      <v-card class="d-flex flex-column align-center">
        <img src="../assets/img/ylw_icoQuiz.png" width="73" />
        <p>
          Quando optar por ter um quiz, preencha as perguntas e respostas que
          deseja que seus cliente vejam.
        </p>
        <v-divider></v-divider>
        <router-link to='/Quiz' style="color: transparent;">
          <h2 class="clique">Saiba mais...</h2>
        </router-link>
      </v-card>
    </v-row>

    <h3 class="copy">Copyright © 2020. Todos os direitos reservados a Cyma Digital. <a class="copy" href="https://qrservice.com.br/termos-de-uso" target="_blank">Leia aqui os Termos e Condições.</a></h3>
  </v-ons-page>
</template>

<style scoped>
#SaibaComoPage {
  margin-left: 256px;
}

.page__content {
  overflow-x: hidden !important;
}

.sub_titulo {
  color: #1a1a1a;
  font-family: "DMSans-Regular" !important;
  font-size: 1.2rem;
  font-weight: bold;
}

.clique {
  cursor: pointer;
  margin-left: 0px !important;
}

.v-card {
  width: 180px;
}

.card_1 h1 {
  color: #333333;
  font-size: 1rem;
  margin-left: 77px;
  text-align: start;
  font-weight: bold;
}

.card_1 h2 {
  color: #666666;
  font-size: 0.9rem;
  font-family: "DMSans-Regular" !important;
  margin-left: 15px !important;
  text-align: start;
  text-transform: none !important;
}

.card_1 img {
  position: absolute;
  left: 10px;
  top: -25px;
  width: 55px;
}

.circulo {
  border-radius: 50% !important;
  width: 55px;
  height: 55px;
  position: absolute;
  left: 10px;
  top: -25px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cliente {
  width: 800px;
  display: flex;
  justify-content: space-around;
  margin: 0 auto;
  margin-top: 50px;
}

.cliente .v-card {
  width: 200px;
  height: 200px;
}

.cliente img {
  position: absolute;
  left: 57px;
  top: -35px;
}

.cliente p {
  margin: 0 10px !important;
  margin-top: 70px !important;
  font-size: 1rem;
  text-transform: none;
  color: #666666;
  line-height: 18px;
}

.habilitar {
  width: 80vw;
  max-width: 1200px;
  display: flex;
  justify-content: space-around;
  margin: 50px auto;
}

.habilitar .v-card {
  width: 15vw;
  max-width: 200px;
  height: 280px;
}

.habilitar img {
  position: absolute;
  left: 57px;
  top: -35px;
}

.habilitar p {
  margin-top: 80px !important;
  font-size: 1rem;
  text-transform: none;
  color: #666666;
  line-height: 18px;
  height: 140px;
}

.habilitar h2 {
  color: #666666;
  font-size: 0.9rem;
  font-family: "DMSans-Regular" !important;
  font-weight: bold;
  text-align: center;
  display: block;
  width: 100%;
  text-transform: none !important;
}

hr {
  width: 85% !important;
  border-width: 1px;
  border-top: 0px;
  border-color: #000 !important;
}

.copy {
  color: #666666;
  font-size: 0.8rem;
  font-family: "DMSans-Regular" !important;
  text-align: center;
  text-transform: none;
}

.page__content {
  overflow-x: hidden !important;
}

ons-row {
  margin-top: 30px;
}
ons-list {
  max-width: 30%;
  margin: 15px auto;
  background: none;
}
ons-list-item {
  background: none;
  margin: 8px;
  background-color: white;
}
.zmdi-check {
  color: #019245;
  font-weight: 1000;
}
.zmdi-close {
  color: red;
  font-weight: 1000;
}
h2 {
  font-family: "DMSans-Bold" !important;
}
h2,
h3,
h5,
p {
  color: #000;
  margin-left: 20px !important;
  margin-right: 20px !important;
}

h4 {
  color: #eac800;
  margin-top: -25px !important;
  margin-left: 20px !important;
  margin-right: 20px !important;
  /*padding: 0px 30px!important;*/
}
h5 {
  font-weight: bold !important;
  font-size: 25px;
}

h6 {
  color: #000;
  font-family: "DMSans-Bold" !important;
  margin-top: -10px;
  font-size: 20px;
}

hr {
  max-width: 90%;

  border-width: 1px;
  border-top: 0px;
  border-color: lightgray;
}

input,
ons-input,
ons-select {
  background-color: #fff;
  width: 50%;
  border-radius: 5px;
  margin-left: 30px;
  margin-right: 30px;
  font-size: 16px;
  height: 40px;
}
v-ons-label {
  width: 50% !important;
  display: inline-flex;
  justify-content: first baseline;
}
.text-input {
  color: gray;
}
</style>
<script>
export default {
  name: "SaibaComo",
  key: "SaibaComo",
  props: ["activeIndex"],
  data() {
    return {
      icoMinhaLoja: "md-close",
      icoCardapio: "md-check",
      icoMesas: "md-close",
      icoFuncoes: "md-close",
      e: {},
      c: { dsNome: "", dsTelefone: "", dsEmail: "", dsDuvida: "" },
      busy: false,
      myStyle:{
        backgroundColor:"#bf272d" 
      },
      myStyle_2:{
        backgroundColor:"#bf272d" 
      },
      myStyle_3:{
        backgroundColor:"#bf272d" 
      },
      myStyle_4:{
        backgroundColor:"#bf272d" 
      },
      myStyle_5:{
        backgroundColor:"#bf272d" 
      },
    };
  },
  mounted() {
    var estab = localStorage.getItem("e");
    this.e = JSON.parse(estab);
    // Minha Loja
    if (
      this.e.dsNome != null &&
      this.e.dsTelefone != null &&
      this.e.dsEndereco != null &&
      this.e.vlEnderecoNumero != null &&
      this.e.dsBairro != null &&
      this.e.idCidade != null &&
      this.e.idEspecialidade != null
    ) {
      this.myStyle.backgroundColor = '#39b34a';
    }
    // QR CODE
    if (this.e.arrMesas.length > 0) {
      this.myStyle_3.backgroundColor = '#39b34a';
    }
    // Funcoes
    if (
      this.e.flMostrarWifi != null &&
      this.e.flChamarGarcom != null &&
      this.e.flPedirConta != null &&
      this.e.flEnviarMsg != null
    ) {
      this.myStyle_4.backgroundColor = '#39b34a';
    }
    // Cardapio
    if(localStorage.getItem('Cardapio') != 0) {
      this.myStyle_2.backgroundColor = '#39b34a';
    }
    // Quiz
    var cdp = JSON.parse(this.e.txQuiz)
    var flag = false;

    if(cdp != null) {
      for(var i in cdp.questions) {
        if(cdp.questions[i].question != '') {
          flag = true;
        }else {
          flag = false;
          break;
        }
      }
      if(flag) {
        this.myStyle_5.backgroundColor = '#39b34a';
      }
    }
  },
  methods: {
    openCardapio() {
      var w = window.open(
        this.$menu_base + "p/" + btoa(this.e.idEstabelecimento),
        "_blank"
      );
      w.focus();
    },
    enviarContato() {
      var error = "";
      if (this.c.dsNome == "") {
        error += "Por favor insira seu nome. ";
      }
      if (this.c.dsEmail == "") {
        error += "Por favor insira um email. ";
      }
      if (this.c.dsDuvida == "") {
        error += "Por favor insira uma mensagem. ";
      }
      if (error != "") {
        this.$ons.notification.toast(error, {
          timeout: 1000,
          animation: "ascend",
        });
        return;
      }
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!re.test(this.c.dsEmail)) {
        this.$ons.notification.toast("Por favor insira um EMAIL válido.", {
          timeout: 1000,
          animation: "ascend",
        });
      } else {
        this.showLoader();
        fetch(this.$menu_uri + "/enviar-contato", {
          method: "OPTIONS",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(this.c),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.send == true) {
              this.$ons.notification.toast("Contato enviado com sucesso.", {
                timeout: 3000,
                animation: "ascend",
              });
              this.showLoader();
              this.c = {
                dsNome: "",
                dsTelefone: "",
                dsEmail: "",
                dsDuvida: "",
                dsSegmento: "",
                idEstabelecimento: this.e.idEstabelecimento,
              };
            } else {
              this.$ons.notification.toast("Ocorreu um erro ao enviar o seu contato.", {
                timeout: 1000,
                animation: "ascend",
              });
              this.showLoader();
            }
          });
      }
    },
    showLoader() {
      this.busy = !this.busy;
    },
  },
};
</script>